import { render, staticRenderFns } from "./SectionChat.vue?vue&type=template&id=0e1c6b44&scoped=true&"
import script from "./SectionChat.vue?vue&type=script&lang=js&"
export * from "./SectionChat.vue?vue&type=script&lang=js&"
import style0 from "./SectionChat.vue?vue&type=style&index=0&id=0e1c6b44&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c6b44",
  null
  
)

export default component.exports